import { WSCard, WSInfoBox } from "@wingspanhq/fe-component-library";
import { getBenefitsEnrollInsuranceFlowPathname } from "../../../../Benefits/paths";
import { IPolicyType } from "../../../../../services/api/insurance/coverage/types";
import { useHistory } from "react-router-dom";
import { IPlanType } from "../../../../../services/api/planEnrollment/types";
import { selectorPlanNameByPlanType } from "../../../../MyResources/selectors/selectorPlanNameByPlanType";
import { useHistoryCheckpoint } from "../../../../../shared/hooks/useHistoryCheckpoint";

type Props = {
  policyType: IPolicyType;
};

export const ENROLL_INSURANCE_FROM_REQUIREMENT_CHECKPOINT =
  "ENROLL_INSURANCE_FROM_REQUIREMENT_CHECKPOINT";

export const CardWingspanInsurance: React.FC<Props> = ({ policyType }) => {
  const history = useHistory();
  const historyCheckpoint = useHistoryCheckpoint(
    ENROLL_INSURANCE_FROM_REQUIREMENT_CHECKPOINT
  );

  const planType: IPlanType = [
    "GeneralLiability",
    "ProfessionalLiability"
  ].includes(policyType)
    ? "WingspanProfessionalLiabilityAndGeneralLiabilityInsurance"
    : "WingspanOccupationalAccidentInsurance";

  const insuranceName = selectorPlanNameByPlanType(planType);

  return (
    <WSCard
      header={{
        label: {
          avatar: {
            type: "icon",
            icon: "shield-check-fill",
            colorBackground: "garnet"
          },
          text: `${insuranceName}`
        }
      }}
      actions={{
        alignment: "fill",
        buttons: [
          {
            label: "Enroll now",
            onClick: () => {
              historyCheckpoint.saveCheckpoint();

              history.push(getBenefitsEnrollInsuranceFlowPathname(planType), {
                backPath: history.location.pathname
              });
            }
          }
        ]
      }}
    >
      <WSInfoBox>
        This requirement accepts {insuranceName} - learn more and join thousands
        of contractors in getting instant coverage today and complete the client
        requirement upon successful enrollment.
      </WSInfoBox>
    </WSCard>
  );
};
